// extracted by mini-css-extract-plugin
export default {"notifications_skeleton_loader":"notifications_skeleton_loader___uebAO","toolip":"toolip___kIM59"};